export const MAX_ZINDEX = 9999;
export const BLANK = "____";
export const REFERRAL_FORM_GUIDELINE_FONTSIZE = 12;
